import React from "react";

import {
    Box,
    Flex,
    Text,
    Stack,
    Divider,
    Badge,
} from "@chakra-ui/react";

import ReusableDrawer from "components/Drawers/ReusableDrawer";

import { formatDate } from "utils/dateFormatter";

const ViewCommissionRuleDrawer = ({
    isOpen,
    onClose,
    rule,
}) => {
    if (!rule) return null;

    return (
        <ReusableDrawer
            isOpen={isOpen}
            onClose={onClose}
            headerContent={
                <Text
                    fontSize="2xl"
                    fontWeight="bold"
                >
                    Commission Rule Details
                </Text>
            }
            bodyContent={
                <Flex
                    direction="column"
                    p={6}
                    width="100%"
                >
                    <Stack spacing={5}>
                        <Box>
                            <Text
                                fontWeight="bold"
                                color="gray.600"
                                fontSize="sm"
                            >
                                Milestone Type
                            </Text>

                            <Text fontSize="md">
                                {rule.milestone_type}
                            </Text>
                        </Box>

                        <Box>
                            <Text
                                fontWeight="bold"
                                color="gray.600"
                                fontSize="sm"
                            >
                                Commission Amount
                            </Text>

                            <Text
                                fontSize="2xl"
                                fontWeight="700"
                                color="#071D54"
                            >
                                P{rule.amount}
                            </Text>
                        </Box>

                        <Divider />

                       

                        <Box>
                            <Text
                                fontWeight="bold"
                                color="gray.600"
                                fontSize="sm"
                            >
                                Active
                            </Text>

                            <Badge
                                mt={2}
                                colorScheme={
                                    rule.active
                                        ? "green"
                                        : "red"
                                }
                                borderRadius="full"
                                px={3}
                                py={1}
                            >
                                {rule.active
                                    ? "Yes"
                                    : "No"}
                            </Badge>
                        </Box>

                        <Divider />

                        <Box>
                            <Text
                                fontWeight="bold"
                                color="gray.600"
                                fontSize="sm"
                            >
                                Effective From
                            </Text>

                            <Text fontSize="md">
                                {formatDate(
                                    rule.effective_from
                                )}
                            </Text>
                        </Box>

                        <Box>
                            <Text
                                fontWeight="bold"
                                color="gray.600"
                                fontSize="sm"
                            >
                                Created At
                            </Text>

                            <Text fontSize="md">
                                {formatDate(
                                    rule.created_at
                                )}
                            </Text>
                        </Box>

                       
                    </Stack>
                </Flex>
            }
        />
    );
};

export default ViewCommissionRuleDrawer;